import React, { useEffect, useRef, useState } from "react";
import "./Membership.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const MISCertificate = () => {
  const [company,setCompany]=useState(null);
  const [nominee,setNominee]=useState(null);
  const [customer,setCustomer]=useState(null);
const { profile } = useSelector((state) => state.userProfile);
const dispatch=useDispatch();
  const componentRef = useRef();

  // static data
const data = {
formNo: "MIS-00123",
scheme: "Regular MIS",
maturityAmount: "₹1,00,000",
tenure: "5 Years",
roi: "7.5% p.a.",
maturityDate: "15/08/2028",
nameOfApplicant: "mohan ram",
fhName: "",
marital: "",
presentAddress: "",
aadhar: "",
gender: "",
dob: "",
pan: "",
mobile: "",
name: "",
age: "",
relation: "",
};

const generatePDF = async () => {
 const input = componentRef.current;
 const canvas = await html2canvas(input,{scale:2, useCORS:true,backgroundColor:"#fff"});
 const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0 , position,imgWidth,imgHeight);
    heightLeft -=pageHeight;

    // for long certificate 
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData,"PNG",0,position,imgWidth,imgHeight);
      heightLeft -=pageHeight;
    }
    pdf.save("Membership.pdf");
  };


  // dynamic data........
 const { state } = useLocation();
 const currentRDRowData = state?.row;
  // console.log("rd row data :", currentRDRowData)


  // Fetch Profile (runs once)
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);
  
  
  // Fetch Company and Nominee 
  useEffect(() => {
    const fetchAllData = async () => {
      if (!profile?.superAdminId) return; // Stop if profile not loaded yet
  
      // Fetch Company
      try {
        const res = await fetch(
          `https://narrowitsolution.in/api/get-company?superAdminId=${profile.superAdminId}`
        );
        const companyData = await res.json();
  
        if (res.ok) {
          // Fix logo URL
          if (companyData.logo) {
            companyData.logoUrl = `https://narrowitsolution.in/${companyData.logo.replace(
              /^images\//,
              ""
            )}`;
          }
          // console.log(companyData)
          setCompany(companyData);
        } else {
          console.error("Company fetch failed:", companyData);
        }
      } catch (err) {
        console.error("Company fetch error:", err);
      }
  
      /* ------------------------- CUSTOMER ------------------------- */
        if (currentRDRowData?.customerId) {
          try {
            const res = await fetch(
              `https://narrowitsolution.in/api/customers-get-userId?customerId=${currentRDRowData.customerId}&branchId=${currentRDRowData.branchId}`
            );

            const data = await res.json();
            // console.log("Customer API Response:", data);
            setCustomer(data.data);
          } catch (err) {
            console.error("Customer fetch error:", err);
          }
        }
      // Fetch Nominee
      try {
        if (currentRDRowData?.customerId) {
          const nomineeRes = await fetch(
            `https://narrowitsolution.in/api/customer-nominee-filter?customerId=${currentRDRowData.customerId}&branchId=${currentRDRowData?.branchId}`
          );
  
          const nomiData = await nomineeRes.json();
  
          // console.log("Nominee Data:", nomiData);
  
          if (nomiData?.data) {
            setNominee(nomiData.data);
          } else {
            setNominee([]); // in case of no nominee
          }
        }
      } catch (error) {
        console.log("Nominee fetch error:", error);
      }
    };
  
    fetchAllData();
  }, [profile?.superAdminId, currentRDRowData?.branchId, currentRDRowData?.customerId]);
  return (
    <div className="Membershipmis-wrapper">
      
         <div id="page2"></div>
      {/* Certificate Content */}
      <div className="Membershipmis-container" ref={componentRef}>
        <header className="Membershipmis-header">
          <h1>{company?.name||"BANKSAN NIDHI LIMITED"}</h1>
          <p>
          Regd./Head Office: {company?.address||"Hanuman Market, Kunwar Singh Colony, Chas - 827013, Bokaro (Jharkhand)"}
          </p>
          <p>
            Website: <span>{company?.domain||"https://banksannidhi.in"}</span> | E-mail:
            {company?.email||"info@banksannidhi.in"}
          </p>
        </header>

        <div className="Membershipmis-title">MemberShip Form</div>

        <div className="Membershipbranch-details">
          <div>Branch Name: ____________________________</div>
          <div>Branch Code: ____________________________</div>
        </div>

        <p className="Membershipto-section">
          To,<br />
          The Chief Executive Officer/Branch Manager<br />
          {company?.name||"BANKSAN NIDHI LTD."}<br />
          {company?.address||"Bokaro, Jharkhand"}
        </p>

        <p className="Membershipfill-text">(please fill in BLOCK letters)</p>

        <p className="Membershipmember-text">
          I, Sri/Smt/Miss {<b>{currentRDRowData?.customerName}</b>||"______________________________________"} opt to be
          Member in “{company?.name||"BANKSAN NIDHI LTD."}” and my detailed particulars are as
          follows:
        </p>

        <table className="Membershipdetails-table">
          <tbody>
            <tr>
              <td><strong> Form No:</strong> {data.formNo||"N/A"}</td>
              <td><strong>Scheme:</strong> {currentRDRowData.schemeName||"N/A"}</td>
              <td rowSpan={6} className="Membershipphoto-box">
                <div className="Membershipphoto-placeholder"
                  >Photo Here</div>
              </td>
            </tr>
            <tr>
              <td><strong>Maturity Amount:</strong> {currentRDRowData.maturityAmount||"N/A"}</td>
              <td><strong>Tenure:</strong> {currentRDRowData.tenure||"N/A"}</td>
            </tr>
            <tr>
              <td><strong>ROI:</strong> {currentRDRowData.roi||"N/A"}</td>
              <td><strong>Maturity Date:</strong> {new Date(currentRDRowData.maturityDate).toLocaleDateString("en-GB")||"N/A"}</td>
            </tr>
            
          </tbody>
        </table>

        <h3 className="Membershipsection-title">PERSONAL INFORMATION</h3>
        <table className="Membershipinfo-table">
          <tbody>
            <tr>
              <td colSpan={3}><strong>Name of Applicant:</strong> {currentRDRowData?.customerName||"N/A"}</td>
              <td><strong>Age:</strong> {"N/A"}</td>
            </tr>
            <tr>
              <td colSpan={3}><strong>Father’s/Husband’s Name:</strong> {customer?.guardianName||"N/A"}</td>
              <td><strong>Marital Status:</strong> {customer?.maritalStatus||"N/A"}</td>
            </tr>
            <tr>
              <td colSpan={4}><strong>Present Address:</strong> {customer?.address||"N/A"}</td>
            </tr>
            <tr>
              <td colSpan={2}><strong>Aadhaar No :</strong> {customer?.aadhaarNumber||"N/A"}</td>
              <td><strong>Gender:</strong> {customer?.gender}</td>
              <td><strong>Date of Birth :</strong> {new Date(customer?.dateOfBirth).toLocaleDateString("en-GB")||"N/A"}</td>
            </tr>
            <tr>
              <td colSpan={2}><strong>PAN No:</strong> {customer?.panNumber||"N/A"}</td>
              <td colSpan={2}><strong>Mobile No:</strong> {customer?.mobileNumber||"N/A"}</td>
            </tr>
          </tbody>
        </table>

        <h3 className="Membershipsection-title">NOMINEE DETAILS</h3>
        <table className="Membershipinfo-table">
          <tbody>
            <tr>
              <td><strong>Name:</strong> {nominee?.nomineeName||"N/A"}</td>
              <td><strong>Dob:</strong> {nominee?.nomineeDob||"N/A"}</td>
              <td><strong>Relationship:</strong> {nominee?.nomineeRelation||"N/A"}</td>
            </tr>
          </tbody>
        </table>

        {/* <h3 className="Membershipsection-title">INTRODUCER DETAILS</h3>
        <table className="Membershipinfo-table">
          <tbody>
            <tr>
              <td>Name :</td>
              <td></td>
              <td>Address :</td>
              <td></td></tr>
            <tr>
              <td>Membership ID:</td>
              <td></td>
              <td>Signature of Introducer:</td>
              <td></td>
            </tr>
          </tbody>
        </table> */}

        <div className="Membershipsign-section">
          <p>Signature of Applicant: __________________________</p>
          <p>Signature of Authorize: __________________________</p>
        </div>
      </div>
    {/* ✅ Print Button */}
      <div className="Membershipprint-btn-container">
        <button className="Membershipprint-btn" onClick={generatePDF}>
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default MISCertificate;